import { IManagerListTypeSummaryLookup } from 'typings/manager';

export class ManagerListTypeSummaryLookup implements IManagerListTypeSummaryLookup {
    private _listType: string;
    private _count: number;

    constructor(managerListTypeSummaryLookupDto: IManagerListTypeSummaryLookup) {
        this._listType = managerListTypeSummaryLookupDto.listType;
        this._count = managerListTypeSummaryLookupDto.count;
    }

    get listType(): string {
        return this._listType;
    }

    get count(): number {
        return this._count;
    }
}